import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

const CloudiDazeAllArtworkStatic = () => {
    return (
      <>
        <div class="masonry-wrap">

            <Masonry columnsCount={2} gutter={"0.75em"}>

                <div>
                    <a href="https://i.imgur.com/JLmPhnL.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/JLmPhnL.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/7VrX9Aa.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/7VrX9Aa.jpg"/>  
                    </a>                    
                </div>

                <div>
                    <a href="https://i.imgur.com/EVZjBkx.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/EVZjBkx.jpg"/>
                    </a>                  
                </div>

                <div>
                    <a href="https://i.imgur.com/GxPLoTa.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/GxPLoTa.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/j8NUaoI.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/j8NUaoI.jpg"/>        
                    </a>          
                </div>

                <div>
                    <a href="https://i.imgur.com/1M5ho8w.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/1M5ho8w.jpg"/>            
                    </a>      
                </div>

                <div>
                    <a href="https://i.imgur.com/CkLQs2t.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/CkLQs2t.jpg"/>      
                    </a>            
                </div>

                <div>
                    <a href="https://i.imgur.com/FYIOQnW.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/FYIOQnW.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/0PwfqHr.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/0PwfqHr.jpg"/>    
                    </a>              
                </div>

                <div>
                    <a href="https://i.imgur.com/x5bQ22k.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/x5bQ22k.jpg"/> 
                    </a>                 
                </div>

                <div>
                    <a href="https://i.imgur.com/KQzuK83.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/KQzuK83.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/udJe3jr.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/udJe3jr.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/Ox46eEo.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/Ox46eEo.jpg"/>        
                    </a>          
                </div>

                <div>
                    <a href="https://i.imgur.com/OGh3Usf.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/OGh3Usf.jpg"/> 
                    </a>                 
                </div>

                <div>
                    <a href="https://i.imgur.com/ZreW7Bk.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/ZreW7Bk.jpg"/>    
                    </a>              
                </div>

                <div>
                    <a href="https://i.imgur.com/pneAJEX.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/pneAJEX.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/YfEM7uv.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/YfEM7uv.jpg"/>     
                    </a>             
                </div>
                
                <div>
                    <a href="https://i.imgur.com/P8ysgnc.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/P8ysgnc.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/C2Z3jcy.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/C2Z3jcy.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/kQcfs3J.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/kQcfs3J.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/d73Ejik.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/d73Ejik.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/vcmlLfQ.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/vcmlLfQ.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/Bch7Z00.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/Bch7Z00.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/SWR6WaK.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/SWR6WaK.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/eEBezmx.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/eEBezmx.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/atuIv93.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/atuIv93.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/BEziKJr.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/BEziKJr.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/BEziKJr.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/BEziKJr.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/FdrkL6A.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/FdrkL6A.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/ou9OnB9.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/ou9OnB9.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/C4DyVy8.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/C4DyVy8.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/eSdoH3M.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/eSdoH3M.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/v0fBXtB.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/v0fBXtB.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/t9yES6p.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/t9yES6p.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/DZTShAX.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/DZTShAX.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/tEZt0qB.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/tEZt0qB.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/y858BvU.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/y858BvU.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/FFgDA3v.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/FFgDA3v.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/ZZ9wtaT.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/ZZ9wtaT.jpg"/>     
                    </a>             
                </div>

                <div>
                    <a href="https://i.imgur.com/xD5OlTB.jpg" target="_blank;" rel="noopener noereferrer">
                        <img src="https://i.imgur.com/xD5OlTB.jpg"/>     
                    </a>             
                </div>

            </Masonry>
        </div>
      </>
    );
  };
  export default CloudiDazeAllArtworkStatic;